import { FC } from "react";

interface CodeBrokkrIFrameProps {
  iframeUrl: string
  iframeTitle: string
}

const CodeBrokkrIFrame: FC<CodeBrokkrIFrameProps> = ({iframeUrl, iframeTitle}) => {
  const iframeStyle = {
    flex: 1,
    width: "100 %",
    height: "100 %",
    border: "none"
  }

  return <iframe src={iframeUrl} title={iframeTitle} style={iframeStyle} loading="lazy"/>
};

export default CodeBrokkrIFrame;